import { render, staticRenderFns } from "./RecoveryContent.vue?vue&type=template&id=ff2f3cc8&scoped=true&"
import script from "./RecoveryContent.vue?vue&type=script&lang=js&"
export * from "./RecoveryContent.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryContent.vue?vue&type=style&index=0&id=ff2f3cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff2f3cc8",
  null
  
)

export default component.exports